import serviceRequest from './service-request/store/index'

export default {
  modules: {
    serviceRequest
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/store.js